export default "__VITE_ASSET__BSZwjtQM__"